<template>
  <div>
    <lista-produtos></lista-produtos>


  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {

  data () {
    return {
      carrinho: {
        nome: "teste 1",
        desc: "outro teste"
      },

      produtos: [
        {
          id: 1,
          nome: "produto 1",
          valor: "5,00"
        },
        {
          id: 2,
          nome: "produto 2",
          valor: "3,00"
        },
        {
          id: 3,
          nome: "produto 3",
          valor: "2,00"
        }
      ]

    }
  },

  methods: {
    ...mapActions([
      'setCarrinho',
    ]),
    adicionarProduto(produto) {
      this.$store.dispatch('adicionarProduto', produto).then();
    },
  },


  created () {
    this.setCarrinho(this.carrinho)
  },

}
</script>

<style>
/* *{
  border: 2px solid red;
} */



</style>